const API_BASE = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

export const DEMO_ROLE_IDS = new Set([3, 4]);

export function extractArray(data) {
  if (Array.isArray(data)) return data;

  if (data && typeof data === "object") {
    if (Array.isArray(data.rows)) return data.rows;
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.users)) return data.users;
    if (Array.isArray(data.data)) return data.data;
  }

  return [];
}

export function normalizeText(value = "") {
  return String(value)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function getUserId(user) {
  return user?.id ?? user?.user_id ?? user?.userId;
}

export function getFullName(user) {
  return `${user?.prenom || ""} ${user?.nom || ""}`.trim() || "Utilisateur";
}

export function isExternalURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
}

export function resolveMediaUrl(url, fallback = "/images/user_avatar.jpg") {
  if (!url) return fallback;

  const value = String(url).trim();

  if (
    isExternalURL(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${API_BASE}${value}`;
  }

  return value;
}

export function getRoleDisplay(roleId) {
  switch (Number(roleId)) {
    case 1:
      return {
        label: "Administrateur",
        short: "Admin",
        className:
          "bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:ring-rose-500/20",
      };
    case 2:
      return {
        label: "Responsable Section",
        short: "Responsable",
        className:
          "bg-indigo-50 text-indigo-700 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20",
      };
    case 3:
      return {
        label: "Démonstration",
        short: "Démo",
        className:
          "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20",
      };
    default:
      return {
        label: "Rôle inconnu",
        short: "Inconnu",
        className:
          "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700",
      };
  }
}

export function getRoleOptions() {
  return [
    { id: 1, label: "Administrateur" },
    { id: 2, label: "Responsable Section" },
    { id: 3, label: "Démonstration" },
  ];
}

export function getSectionName(sections, sectionId) {
  if (!sectionId) return "Aucune section";

  const section = sections.find(
    (item) => String(item.id) === String(sectionId),
  );

  return section?.nom_section || "Section inconnue";
}

export function getStats(users) {
  return {
    total: users.length,
    admins: users.filter((user) => Number(user.role_id) === 1).length,
    responsables: users.filter((user) => Number(user.role_id) === 2).length,
    demos: users.filter((user) => Number(user.role_id) === 3).length,
  };
}

export function getCurrentStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

export function isDemoMode() {
  const user = getCurrentStoredUser();
  return DEMO_ROLE_IDS.has(Number(user?.role_id));
}

export function buildUserPayload(formData, mode = "create") {
  const payload = {
    nom: formData.nom,
    prenom: formData.prenom,
    email: formData.email,
    role_id: Number(formData.role_id),
    section_id: formData.section_id ? Number(formData.section_id) : null,
    photoURL: formData.photoURL || "",
  };

  if (mode === "create") {
    payload.password = formData.password;
  }

  if (mode === "edit" && formData.password?.trim()) {
    payload.password = formData.password;
  }

  return payload;
}
